exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".userManagement-wrap .tooltip:hover {\n  color: #40AEFC;\n}\n.userManagement-wrap .table-ellipsis {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 100px;\n}\n", ""]);

// exports
